import { Box } from "@mui/material";
import TopProducts from "../../components/sections/dashboard/top-products/TopProducts";
import TrendingNow from "../../components/sections/dashboard/trending-now/TrendingNow";
import Customers from "../../components/sections/dashboard/customers/Customers";
import Earnings from "../../components/sections/dashboard/earnings/Earnings";
import CustomerFulfillment from "../../components/sections/dashboard/customer-fulfilment/CustomerFulfillment";
import Level from "../../components/sections/dashboard/level/Level";
import VisitorInsights from "../../components/sections/dashboard/visitor-insights/VisitorInsights";
import TodaysSales from "../../components/sections/dashboard/todays-sales/TodaysSales";

const FarmOwnerDashboard = () => {
  return (
    <>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3.5}>
        <Box gridColumn={{ xs: "span 12", "2xl": "span 8" }} order={{ xs: 0 }}>
          <TodaysSales />
        </Box>
        <Box
          gridColumn={{ xs: "span 12", lg: "span 4" }}
          order={{ xs: 1, "2xl": 1 }}
        >
          <Level />
        </Box>
        <Box
          gridColumn={{ xs: "span 12", lg: "span 8" }}
          order={{ xs: 2, "2xl": 2 }}
        >
          <TopProducts />
        </Box>
        <Box
          gridColumn={{ xs: "span 12", md: "span 6", xl: "span 4" }}
          order={{ xs: 3, xl: 3, "2xl": 3 }}
        >
          <CustomerFulfillment />
        </Box>
        <Box
          gridColumn={{ xs: "span 12", md: "span 6", xl: "span 4" }}
          order={{ xs: 4, xl: 5, "2xl": 4 }}
        >
          <Earnings />
        </Box>
        <Box
          gridColumn={{ xs: "span 12", xl: "span 8" }}
          order={{ xs: 5, xl: 4, "2xl": 5 }}
        >
          <VisitorInsights />
        </Box>
        <Box
          gridColumn={{ xs: "span 12", xl: "span 8", "2xl": "span 6" }}
          order={{ xs: 6, "2xl": 6 }}
        >
          <TrendingNow />
        </Box>
        <Box gridColumn={{ xs: "span 12", "2xl": "span 6" }} order={{ xs: 7 }}>
          <Customers />
        </Box>
      </Box>
    </>
  );
};

export default FarmOwnerDashboard;
